import { createReducer, on } from '@ngrx/store';
import * as DashboardActions from './dashboard.action';
import { initialDashboardState } from './dashboard.state';

export const dashboardReducer = createReducer(
    initialDashboardState,

    on(DashboardActions.setTenantStatsCount, (state, { counts }) => ({
        ...state,
        counts,
    })),
);
